<template>
  <div>
    <el-table :data="networks" style="width: 100%; min-width:500px;" :cell-class-name="classChecker" @sort-change="sort" @filter-change="filterChange">

      <el-table-column prop="name">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Name"
              :status-sort="sortBy"
              sort-key="name"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column width="150px" prop="tag">
        <template slot="header" slot-scope="scope">
          <header-sort-title
                  @sort="sort"
                  title="Tag"
                  :status-sort="sortBy"
                  sort-key="tag"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.assignedTags.toString() }}
        </template>
      </el-table-column>

      <el-table-column width="150px" prop="network_work">
        <template slot="header" slot-scope="scope">
          Work
        </template>
        <template slot-scope="scope">
          {{ scope.row.work }}
        </template>
      </el-table-column>

      <el-table-column
          width="150px"
          label="Status"
          prop="status"
          sortable="custom"
          :status-sort="sortBy"
          sort-key="status"
          column-key="status"
          :filters="[
              {text: 'Inactive', value: 0 },
              {text: 'Active', value: 1 },
              {text: 'New', value: 2},
              {text: 'Can\'t implement', value: 3},
              {text: 'Pending', value: 4},
          ]"
      >
        <template slot-scope="scope">
          {{ getStatus(scope.row.status) }}
        </template>
      </el-table-column>

      <el-table-column width="150px" prop="network_status"  >
        <template slot="header" slot-scope="scope">
          Workable
        </template>
        <template slot-scope="scope">
          {{ getStatusString(scope.row.function) }}
        </template>
      </el-table-column>

      <el-table-column width="150px" align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteNetwork(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagin-wrp">
      <el-pagination
          :current-page="chosenPageFromVuex"
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="networksMeta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

  import HeaderSortTitle from '../UsersList/HeaderSortTitle'
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: "NetworkTableList",
    components: {
      HeaderSortTitle,
    },
    props: {
      pageLabel: String,
      filterProps: {}
    },
    data () {
      return {
        filterNets: '',
        sortBy: {
          name: 0,
          status: 0,
        },
        filterBlock:this.filterProps,
      }
    },
    computed: {
      ...mapGetters({
        networks: 'networks/getNetworks',
        networksStatuses: 'networks/getNetworksStatuses',
        networksMeta: 'networks/getNetworksMeta',
        selectedFilter: 'networkNetworksFilter/getSelectedFilter',
        chosenPageFromVuex: 'networkNetworksFilter/getChosenPage',
      }),
      chosenPage: {
          get() {
              return this.chosenPageFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkNetworksFilter/updateChosenPage', value);
          },
      },       
    },

    created () {
      this.updateNetworkList();
      this.loadData();
    },

    watch:{
      getSelectedFilter: {
        immediate: true,
        handler(value) {
          if (value) {
            this.handleFilterChange(value);
          }
        },
      },        
    },

    methods: {
      ...mapActions({
        'updateSelectedFilter': 'networkNetworksFilter/updateSelectedFilter',
        'updateFilterBlock': 'networkNetworksFilter/updateFilterBlock'
      }),
      ...mapGetters('filterBlock', ['getFilterBlock']),      

      loadData() {
        this.filterBlock = this.getFilterBlock;
        this.updateNetworkList();
      },      
      handleFilterChange(filter) {
        this.updateSelectedFilter(filter);
      }, 

      filterChange(filter) {
        this.filterBlock = filter
        this.$emit('updateContent',  this.filterBlock)
        this.handleFilterChange(filter);
        this.updateNetworkList()
      },
      chosePage (e) {
        this.chosenPage = e
        this.updateNetworkList()
      },
      sort(by) {
        let key  = (typeof by ==="object") ? by.prop : by
        console.log(key)

        if (this.sortBy[key] === 0) {
          this.sortBy[key] = 1
        } else if (this.sortBy[key] === 1) {
          this.sortBy[key] = -1
        } else if (this.sortBy[key] === -1) {
          this.sortBy[key] = 0
        }
        if(typeof by ==="object" && by.order==null){
          this.sortBy[key] = 0
        }
        this.updateNetworkList()
      },
      updateNetworkList() {
        let params = 'sort='
        if (this.sortBy) {
          for (let itm in this.sortBy) {
            if (this.sortBy[itm] === 1) {
              params = `${params}${itm},`
            } else if (this.sortBy[itm] === -1) {
              params = `${params}-${itm},`
            }
          }
        }
        if (params === 'sort=') {
          params = ''
        }
        params = `${params}&page=${this.chosenPage}`
        if (this.countNets) {
          params = `${params}&per_page=${this.countNets}`
        }
        if (this.filterNets.length) {
          params = `${params}&filter=${this.filterNets}`
        }
        if(this.pageLabel) {
          params = `${params}&group=${this.pageLabel}`
        }

        if (this.selectedFilter) {
          this.filterBlock = this.selectedFilter; 
          this.handleFilterChange(this.filterBlock);
        } 

        if (typeof this.filterBlock != 'undefined' && Object.keys(this.filterBlock).length) {
          Object.entries(this.filterBlock).forEach(([key, value]) => {
            if(value.length === 0){
              return;
            }
            params = `${params}&${key}=`+JSON.stringify(value)
          });
        }
        this.$store.dispatch('networks/getNetworks', params)
      },
      deleteNetwork(netData) {
        this.$store.dispatch('networks/deleteNetwork', netData.id)
      },
      handleEdit(index, row) {
        this.$router.push({name: 'network-edit', params: {id: row.id}})
      },
      getStatus(status) {
        switch (status) {
          case 0:
            return 'Inactive';
          case 2:
            return 'New';
          case 3:
            return 'Can\'t implement';
          case 4:
            return 'Pending';
          case 1:
          default:
            return 'Active';
        }
      },
      getStatusString(network) {
        if (!this.networksStatuses[network]) {
          return 'Undefined'
        }

        return (this.networksStatuses[network].found ? 'Passed' : 'Failed')
            + ' / '
            + (this.networksStatuses[network].not_found ? 'Passed' : 'Failed');
      },
      getStatusWorkable(network) {
        if (!this.networksStatuses[network]) {
          return -1
        }
        let test_result = this.networksStatuses[network].found + this.networksStatuses[network].not_found
        let check_test = this.networksStatuses[network].check_test;
        return {"search": test_result, "check": check_test}
      },
      classChecker({row, column}) {
        if (column.property === 'network_status') {
          const val = this.getStatusWorkable(row['function'])
          if(val== -1){
            return
          }
          if (val.check == 1) {
            return 'bg-danger-lighter'
          }
          if (val.search > 1) {
            return 'bg-success-lighter'
          }
          if (val.search == 3) {
            return 'bg-primary'
          }
          if (val.search <= 1) {
            return 'bg-warning-lighter'
          }
        }
      }
    }

  }
</script>

